import { useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useSelector } from "react-redux";

import { getVatInfoFor } from "@/redux/modules/value/vatInfo/vatInfo.selectors";

import { VatFieldValues } from "./vatField.schema";

const VatInfoHandler = () => {
    const { getValues, setValue } = useFormContext<VatFieldValues>();

    const watchedValue = useWatch({
        name: "vatInfo.vatNr"
    });

    const vatInfo = useSelector(getVatInfoFor(watchedValue));

    useEffect(() => {
        if (!vatInfo?.companyName) return;

        const formVatInfo = getValues("vatInfo");
        if (!formVatInfo) return;

        if (
            formVatInfo.vatNr === vatInfo.vatNr &&
            formVatInfo.vatNrPrefix === vatInfo.vatNrPrefix &&
            // Don't override company name if it's already set
            !formVatInfo.companyName
        ) {
            setValue("vatInfo.companyName", vatInfo.companyName);
        }
    }, [vatInfo, getValues, setValue]);

    return null;
};

export { VatInfoHandler };
